import Modal from "@hg/modal"
import {
    isMobileDevice,
    useOwnTeam,
    useUser,
} from "@hg/recall-frame"
import cls from "classnames"
import classNames from "classnames"
import { useRoleInfo } from "@/user/session"
import React, {
    Dispatch,
    FC,
    useEffect,
    useMemo,
    useRef,
    useState,
} from "react"

import { sfx, sfxPlay } from "@/assets/audios/sfx"
import { Close } from "@/components/Close"
import { CommonTransition } from "@/components/CommonTransition"
import Toast from "@/components/Toast"
import { i18n } from "@/i18n"
// import { CommonTransition } from "@/components/CommonTransition"
// import { Close } from "@/components/Close"
// import BGSrc from "@/assets/imgs/recall/draw-back.png"
import { collect } from "@/utils/sdk"
import { downloadShareImage, onImageSaved } from "@/utils/share"
// import { RuleButton } from "@/Topics/Recall/components/Modals/Rules"
import { drawShareImg } from "./draw"
import styles from "./index.module.scss"
import OutlineButton from "@/components/OutlineButton"
import { ShareChannels } from "@/components/ShareChannels"

export const Share: FC<{
    open: boolean
    setOpen: Dispatch<boolean>
    onSubmit: () => Promise<void>
}> = ({ open, setOpen, onSubmit }) => {
    const role = useRoleInfo()
    const user = useUser()
    const ownTeam = useOwnTeam()

    const onClose = () => setOpen(false)

    const handleOpen = () => {
        if (role) {
            collect("event_share", {
                target: `share_button`,
            })
        }

        setOpen(true)
        sfxPlay("click")
    }

    const previewShare = () => {
        showSharePreview({
            kv: images[idx],
            nickname: user?.nickName,
            uid: user?.uid,
            defaultText: i18n.getRecall("share.default_text"),
            code: ownTeam.data?.code,
            downloadTitle: i18n.getRecall("share.share_title"),
        })
        if (user) {
            onSubmit()
        }
        collect("share_button", {
            button_name: "recall",
        })
    }

    const [idx, setIdx] = useState(0)

    const images = useMemo(() => {
        return [
            require("@/assets/imgs/recall/cg/share_content_1.jpg"),
            require("@/assets/imgs/recall/cg/share_content_2.jpg"),
            require("@/assets/imgs/recall/cg/share_content_3.jpg"),
            require("@/assets/imgs/recall/cg/share_content_4.png"),
        ]
    }, [])

    const container = useMemo(() => {
        const con = Modal.createContainer("_shareModal")
        con.rootElem.style.zIndex = "997"
        return con
    }, [])

    return (
        <>
            <div className={styles.shareButton} onClick={handleOpen} />

            <Modal
                active={open}
                onClose={onClose}
                contentClassName={styles.shareModal}
                container={container}
            >
                <div className={styles.wrap}>
                    <div className={styles.main}>
                        <ImgSwitcher
                            currentIndex={idx}
                            setCurrentIndex={setIdx}
                            images={images}
                        />
                        <div
                            className={classNames(
                                styles.slogan,
                                !user && styles.noUser,
                            )}
                        >
                            <div className={styles.inner}>
                                {user?.nickName && ownTeam.data && (
                                    <>
                                        <div className={styles.label}>
                                            Dr.{user.nickName}
                                        </div>
                                        <div className={styles.number}>
                                            {ownTeam.data.code}
                                        </div>
                                    </>
                                )}
                                {!user && (
                                    <div className={styles.number}>
                                        {i18n.getRecall("share.default_text")}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                    <OutlineButton
                        text={i18n.getRecall("share.submit")}
                        className={styles.btn}
                        onClick={previewShare}
                        fillGradient={{ from: "#FFFBF7", to: "#FDF2D3" }}
                        strokeColor="#882F19"
                        strokeWidth={8}
                        fontSize={40}
                    />
                    <Close className={styles.close} onClose={onClose} />
                </div>
            </Modal>
        </>
    )
}

const previewModal = Modal.createContainer("_previewModal")
previewModal.rootElem.style.zIndex = "998"

const showSharePreview = async ({
    kv,
    uid,
    nickname,
    code,
    defaultText,
    downloadTitle,
}: {
    kv: string
    uid?: string
    nickname?: string
    code?: string
    defaultText: string
    downloadTitle: string
}) => {
    if (!kv) {
        return
    }
    const isMobile = isMobileDevice()

    const src = await drawShareImg({
        kv,
        uid,
        nickname,
        code,
        defaultText,
    })

    if (!src) {
        return
    }

    const download = () => {
        downloadShareImage(src, "recall")
    }

    previewModal.show(
        ({ onClose }) => {
            const shareImageRef = React.useRef<HTMLImageElement>(null)
            return (
                <div
                    className={cls(
                        styles.preview,
                        isMobile ? styles.mobile : null,
                    )}
                >
                    <div className={styles.wrap}>
                        <img
                            ref={shareImageRef}
                            src={src}
                            className={styles.canvas}
                            onContextMenu={() => {
                                onImageSaved("recall")
                            }}
                            alt="share"
                        />
                        <img
                            src={src}
                            className={cls(styles.canvas, styles.rotateImgMask)}
                            onContextMenu={() => {
                                onImageSaved("recall")
                            }}
                            alt="share"
                            onClick={() => {}}
                        />
                    </div>
                    {isMobile && (
                        <div className={styles.info}>
                            {i18n.getRecall("share.share_info")}
                        </div>
                    )}

                    <OutlineButton
                        className={styles.download}
                        text={i18n.getRecall("share.btn_save")}
                        onClick={download}
                        fillGradient={{ from: "#FFFBF7", to: "#FDF2D3" }}
                        strokeColor="#882F19"
                        strokeWidth={8}
                        fontSize={30}
                    />
                    <Close className={styles.close} onClose={onClose} />
                    <ShareChannels
                        code={code}
                        src={src}
                        uid={uid}
                        nickname={nickname}
                        download={download}
                        isRecall
                        shareImageRef={shareImageRef}
                    />
                </div>
            )
        },
        { maskClassName: "modal-mask" },
    )

    return
}

const ImgSwitcher: FC<{
    images: string[]
    currentIndex: number
    setCurrentIndex: Dispatch<React.SetStateAction<number>>
}> = ({ images, currentIndex, setCurrentIndex }) => {
    // 切换到下一张图片
    const handleNext = () => {
        sfx.play("click")
        setCurrentIndex((prevIndex: number) => (prevIndex + 1) % images.length)
    }

    // 切换到上一张图片
    const handlePrev = () => {
        sfx.play("click")
        setCurrentIndex((prevIndex) =>
            prevIndex === 0 ? images.length - 1 : prevIndex - 1,
        )
    }

    const frameRef = useRef<HTMLDivElement>(null)

    return (
        <div className={styles.switcher}>
            <div className={styles.border}>
                <div className={styles.inner}>
                    <CommonTransition
                        state={String(currentIndex)}
                        nodeRef={frameRef}
                    >
                        <div className={styles.frame} ref={frameRef}>
                            {Array.from(
                                Array(images.length).keys(),
                                (n) => n + 1,
                            ).map((q) => {
                                return (
                                    currentIndex === q - 1 && (
                                        <img
                                            key={`share-img-${q}`}
                                            src={images[q - 1]}
                                            alt="share"
                                        />
                                    )
                                )
                            })}
                        </div>
                    </CommonTransition>
                </div>
            </div>
            <div className={styles.switch}>
                <div
                    className={cls(styles.bar, styles.left)}
                    onClick={handlePrev}
                >
                    <Thumb />
                </div>
                <div
                    className={cls(styles.bar, styles.right)}
                    onClick={handleNext}
                >
                    <Thumb />
                </div>
            </div>
        </div>
    )
}

const Thumb = () => {
    return (
        <img
            className={styles.thumb}
            src={require("@/assets/imgs/recall/arrow.png")}
            alt="arrow"
        />
    )
}
